import React, { useState, useEffect } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSun as farSun, faFaceLaughBeam as farFaceLaughBeam } from "@fortawesome/free-regular-svg-icons";
import { faBed, faSun, faChampagneGlasses } from "@fortawesome/free-solid-svg-icons";

const weekdayFormatter = new Intl.DateTimeFormat("en-US", { weekday: "long" });
const calendarDateFormatter = new Intl.DateTimeFormat("en-US", {
    day: "numeric",
    month: "long",
    year: "numeric",
});
const timeFormatter = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
});

function Clock() {
    const [date, setDate] = useState(new Date());

    // this useEffect is necessary for function of the clock
    useEffect(() => {
        const timerId = setInterval(() => {
            setDate(new Date());
        }, 1000);

        return () => clearInterval(timerId);
    }, []);

    const day = weekdayFormatter.format(date);
    const calendarDate = calendarDateFormatter.format(date);
    const time = timeFormatter.format(date).toLowerCase();
    const formattedDate = `${day}, ${calendarDate}, ${time}`;

    const hours = date.getHours();
    const minutes = date.getMinutes();

    let icon = "";
    if (hours >= 6 && hours < 8) {
        icon = faBed;
    } else if (hours >= 8 && hours < 14) {
        icon = farSun;
    } else if (hours === 17 && minutes === 0) {
        icon = faChampagneGlasses;
    } else if (hours >= 14 && hours < 17) {
        icon = faSun;
    } else {
        icon = farFaceLaughBeam;
    }

    return (
        <span style={{ fontSize: "0.85rem" }}>
            {formattedDate} <FontAwesomeIcon icon={icon} fixedWidth className="ms-2" />
        </span>
    );
}
export default Clock;
